<template>
  <el-dialog title="" :visible.sync="dialogVisible" width="540px">
    <div class="topTitle">
      <span>转让</span>
      <!-- <span v-if="data.bsFlag == '卖出'" class="buyTitle">买入转让</span>
      <span v-if="data.bsFlag == '买入'" class="sellTitle">卖出转让</span> -->
    </div>
    <div class="nameStyle">
      {{ data.commodityCode }}&nbsp;&nbsp;{{ data.commodityName }}
    </div>
    <div class="inputWrap">
      <p class="title">
        转让价格
        <!-- {{
          data.bsFlag == '卖出'? '买入价格' : '卖出价格'
        }} -->
      </p>
      <div class="content">
        <el-input v-model.number="price" placeholder="请输入转让价格" type="number" @input="limitTransPrice">
        </el-input>
      </div>
    </div>
    <div class="inputWrap wrapSun">
      <p class="title">
        <span>
          转让数量
          <!-- {{ type=='1'?'存货数量':'转让数量' }} -->
        </span>
      </p>
      <div class="content">
        <el-input v-model.number="holdQuality" :disabled="type=='1'" type="number" @input="limitTransNum">
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="conBtn"
        type="primary"
        style="color:#272727;"
        @click="stopConfirm"
      >确 定</el-button>
        <el-button
        class="canelBtn"
        @click="cancleDialog"
        style=""
      >取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
/*global http protocol hqWs hqProtocol*/
import { mapGetters } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      dialogVisible: false,
      data: {},
      input: '',
      price: '',
      holdQuality: 0, // 存货数量
      isRepeat: false,
      firstQuality: 0
    }
  },
  computed: {
    ...mapGetters(['marketDetails', 'buyOrderLst', 'sellOrderLst']),
    newPrice() {
      // 默认展示最新价
      for (let i = 0; i < this.marketDetails.length; i++) {
        const ele = this.marketDetails[i]
        if (this.data.commodityId == ele.symbolId) {
          return ele.close
        }
      }
      return ''
    }
  },
  methods: {
    limitTransNum(value) {
      if (value) {
        const numStr = new RegExp('^(\\d+)\\.(\\d{0,' + this.data.amountScale + '}).*$')
        value = value.replace(numStr, '$1.$2')
        this.holdQuality = value
      }
    },
    limitTransPrice(value) {
      if (value) {
        const numStr = new RegExp('^(\\d+)\\.(\\d{0,' + this.data.priceScale + '}).*$')
        value = value.replace(numStr, '$1.$2')
        this.price = value
      }
    },
    showDialog(row) {
      if (this.type === '1') {
        // 持仓明细
        this.data = row
        // this.holdQuality = row.quantity - row.frozeQuantity
        this.holdQuality = row.availableQuantity
        this.dialogVisible = true
      } else {
        // 持仓汇总
        this.data = row
        this.holdQuality = Number(row.quantity) - Number(row.frozeQuantity) - Number(row.optimizeQuantity)
        this.firstQuality = this.holdQuality
        this.dialogVisible = true
      }
      setTimeout(() => {
        if (this.data.bsFlag == '卖出') {
        // 对应销售1的价格
          if (this.sellOrderLst[0][0] != '--') {
            this.price = this.sellOrderLst[0][0]
          } else {
            this.price = null
          }
        } else if (this.data.bsFlag == '买入') {
        // 对应采购1的价格
          if (this.buyOrderLst[0][0] != '--') {
            this.price = this.buyOrderLst[0][0]
          } else {
            this.price = null
          }
        }
      }, 200)
    },
    isEmpty(param) {
      if (param === null || param === undefined || param === '') {
        return true
      } else {
        return false
      }
    },
    cancleDialog() {
      hqProtocol.param_untoporder.contractIds = [this.data.commodityId]
      hqWs.send(hqProtocol.param_untoporder)
      this.$store.commit('buyOrderLst', [])
      this.$store.commit('sellOrderLst', [])
      this.price = null
      this.dialogVisible = false
    },
    // 提示音播放
    createPlayer() {
      if (window.g.FAST_SET.FAST_Ordersuccess_Playsound) {
        const audio = new Audio(require('../../../assets/voice/1.mp3'))
        audio.play()
      }
    },
    stopConfirm() {
      if (this.isEmpty(this.price)) {
        return this.$message('请输入价格')
      }
      if (this.type === '2') {
        if (this.isEmpty(this.holdQuality)) {
          return this.$message('请输入转让数量')
        } else if (Number(this.holdQuality) > Number(this.firstQuality)) {
          return this.$message('超出可转让数量')
        }
      }
      if (this.isRepeat) {
        return
      } else {
        this.isRepeat = true
      }
      if (this.type === '1') {
        protocol.param_transfer.param = {
          holdDetailId: this.data.holdDetailId,
          price: this.price,
          quantity: this.holdQuality
        }
        http.postFront1(protocol.param_transfer).then(response => {
          const { code, message } = response.data
          if (code == '0') {
            this.isRepeat = false
            this.price = null
            this.dialogVisible = false
            hqProtocol.param_untoporder.contractIds = [this.data.commodityId]
            hqWs.send(hqProtocol.param_untoporder)
            this.$store.commit('buyOrderLst', [])
            this.$store.commit('sellOrderLst', [])
            this.$message(message)
            this.createPlayer()
            this.$emit('reLoad')
          } else {
            this.$message(message)
            this.isRepeat = false
          }
        }).catch(error => {
          this.$message(error)
          this.isRepeat = false
        })
      } else {
        protocol.param_holdTransfer.param = {
          holdId: this.data.holdId,
          price: this.price,
          quantity: this.holdQuality
        }
        http.postFront1(protocol.param_holdTransfer).then(response => {
          const { code, message } = response.data
          if (code == '0') {
            this.isRepeat = false
            this.dialogVisible = false
            hqProtocol.param_untoporder.contractIds = [this.data.commodityId]
            hqWs.send(hqProtocol.param_untoporder)
            this.$message(message)
            this.$emit('reLoad')
          } else {
            this.$message(message)
            this.isRepeat = false
          }
        }).catch(error => {
          this.$message(error)
          this.isRepeat = false
        })
      }

      // this.dialogVisible = false
      // this.$emit('reLoad')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-pagination{
  text-align: center;
}
/deep/ .el-pager li{
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 12px;
  color: #E8E8E8;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
/deep/ .el-dialog input,
/deep/ .el-dialog .el-input__inner {
  border: 1px solid rgba(220, 223, 230, 0.6) !important;
  background-color: transparent;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/input[type="number"]{
  -moz-appearance: textfield;
}

/deep/ .el-dialog {
  background: #1a1a1a !important;
  border-radius: 8px;
  border: 1px solid #545454;
  font-size: 18px;
  height: 354px;
  // padding-top: 30px;
  .el-dialog__headerbtn {
    display: none;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-button{
    padding: 0;
  }
  .canelBtn.el-button{
    width: 74px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #404040;
    background-color: transparent;
  }
  .canelBtn span {
   font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #DFDFDF;
    }
   .conBtn.el-button--primary{
    border-radius: 12px;
    width: 74px;
    height: 24px;
    line-height: 24px;
    background-color: #272727;
    border: none;
   }
  .conBtn span {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #DFDFDF;
  }
  .el-dialog__footer {
    text-align: center;
    padding: 0;
    margin-top: 35px;
  }
  .el-checkbox{
    margin-right: 10px;
    height: 32px;
    line-height: 32px;
  }
  .topTitle {
    text-align: center;
    color: #909399;
    font-weight: 600;
    font-size: 24px;
    color: #41b37d;
  }
  .el-dialog__body{
    padding: 20px 40px 0 40px;
  }
  .nameStyle {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0 15px 0;
    padding-bottom: 0px;
  }
  .inputWrap {
    .title {
       color: #FFFFFF;
    //   color: #909399;
      padding-bottom: 10px;
      margin-top: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      .el-input__inner{
        color: #D0D1D5 !important;
      }
      .el-input {
        height: 32px;
        color: #D0D1D5;
      }
      .el-input__suffix-inner {
        top: 6px;
        span {
          color: #909399;
        }
      }
      .textStyle {
        color: #909399;
        height: 32x;
        line-height: 32px;
        padding-left: 9px;
        span {
          color: #909399;
        }
      }
    }
  }
  .wrapYing {
    .title {
      span {
        color: #ef5557;
      }
    }
  }
}
</style>
